import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { RecruiterMode } from './RecruiterMode';
import { ExecutiveMode } from './ExecutiveMode';
interface ModeToggleProps {
  mode: 'recruiter' | 'executive';
}
export function ModeToggle({
  mode
}: ModeToggleProps) {
  return <section id="leadership" className="py-24 lg:py-32 bg-[#F7F7F5]" aria-labelledby="leadership-heading" data-id="element-476">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-477">
        {/* Section label */}
        <div className="mb-12" data-id="element-478">
          <span className="inline-flex items-center gap-2 text-[#B08D57] text-xs font-body font-semibold tracking-[0.2em] uppercase mb-3" data-id="element-479">
            <span className="w-6 h-px bg-[#B08D57]" aria-hidden="true" data-id="element-480" />
            Leadership
          </span>
          <h2 id="leadership-heading" className="font-heading font-bold text-[#1C1F23] text-3xl lg:text-4xl mb-2" data-id="element-481">
            {mode === 'recruiter' ? 'Measurable Enterprise Impact' : 'How I Lead & Why It Works'}
          </h2>
          <p className="font-body text-[#4A5A66]" data-id="element-482">
            {mode === 'recruiter' ? 'Toggle to Executive View in the navigation for the full leadership narrative.' : 'Toggle to Recruiter View in the navigation for quantified outcomes.'}
          </p>
        </div>

        {/* Mode content with animated transition */}
        <div className="relative min-h-[400px]" data-id="element-483">
          <AnimatePresence mode="wait" data-id="element-484">
            {mode === 'recruiter' ? <motion.div key="recruiter" initial={{
            opacity: 0,
            x: -24
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: 24
          }} transition={{
            duration: 0.35,
            ease: 'easeInOut'
          }} data-id="element-485">
                <RecruiterMode data-id="element-486" />
              </motion.div> : <motion.div key="executive" initial={{
            opacity: 0,
            x: 24
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -24
          }} transition={{
            duration: 0.35,
            ease: 'easeInOut'
          }} data-id="element-487">
                <ExecutiveMode data-id="element-488" />
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </section>;
}